module.exports = __webpack_public_path__ + "static/media/sound.f3e1419d.mp3";